/** React Query key factory for the per-clinician signature record.
 *
 *  Single key — there's only one signature per clinician. Mutations
 *  invalidate ``signatureKeys.all`` to refetch the panel preview.
 */
export const signatureKeys = {
  all: ['signature'] as const,
};
